module.exports = __webpack_public_path__ + "static/media/7.daef1616.jpeg";